var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.persons,"item-text":_vm.text,"item-value":_vm.value,"dense":"","outlined":"","filled":"","clearable":"","label":"Seleccione una persona","no-data-text":"No hay personas"},on:{"change":_vm.setPerson},model:{value:(_vm.person),callback:function ($$v) {_vm.person=$$v},expression:"person"}})
}
var staticRenderFns = []

export { render, staticRenderFns }